// extracted by mini-css-extract-plugin
export default {"tabs":"_1zXpSYTlL5"};
    if(module.hot) {
      // 1623933206544
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  